// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"e77a9c26","administration":"b433880e"}[chunkId] + ".chunk.js";
};